import React from "react";
import {
  Field,
  Fieldset,
  FieldGroup,
  Label,
} from "../../../../design/fieldset";
import { Input } from "../../../../design/input";
import { Textarea } from "../../../../design/textarea";
import { Participant } from "../../../../models/Participant";

interface Props {
  formState: {
    file: File | null;
    name: string;
    description: string;
  };
  setFormState: React.Dispatch<
    React.SetStateAction<{
      file: File | null;
      name: string;
      description: string;
    }>
  >;
}

const FileDetailsStep: React.FC<Props> = ({ formState, setFormState }) => {
  const update = (field: keyof typeof formState, value: any) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <Fieldset>
      <FieldGroup>
        <Field>
          <Label>Name</Label>
          <Input
            type="text"
            value={formState.name}
            onChange={(e) => update("name", e.target.value)}
            placeholder="Name"
          />
        </Field>

        <Field>
          <Label>Description</Label>
          <Textarea
            value={formState.description}
            onChange={(e) => update("description", e.target.value)}
            placeholder="Description"
          />
        </Field>
      </FieldGroup>
    </Fieldset>
  );
};

export default FileDetailsStep;
